import React from 'react';
import './projectTransaction.css';
import { Outlet } from 'react-router-dom';

function ProjectTransaction() {
  return (
    <div>
      <Outlet></Outlet>
    </div>
  );
}

export default ProjectTransaction;
